import { useMemo } from 'react';
import { CatalogItem } from '../../../../../redux/api/fymAPI.types';
import { useAccountId } from '../../../../../redux/slices/appInfo/hooks';
import { useIsNativeEmbed } from '../../../navigation/hooks/useIsNativeEmbed';
import { AddSongFrom, catalogAddSongPath } from '../../../../smartLinks/catalog/addSong/catalogAddSongPath';
import { draftFinishStep } from './releaseDraft';

/**
 * The "Finish setup" path of a draft: the next step of the "Add a song" page
 * (`/catalog/new?item=&step=&from=<from>`; the router adds `/app`). Null for a song that is not a
 * draft, and in the native web view: the native apps keep their own add-song screens. The Releases
 * list and the Catalog rows (design catalog-add-song h4) use it; Close of the flow goes back to `from`.
 */
export function useDraftFinishSetupPath(item: CatalogItem, from: AddSongFrom = 'releases'): string | null {
  const isNativeEmbed = useIsNativeEmbed();
  const accountId = useAccountId();
  return useMemo(() => {
    if (isNativeEmbed) {
      return null;
    }
    const step = draftFinishStep(item);
    if (step === null) {
      return null;
    }
    return catalogAddSongPath({ item: item.uuid, step, from, accountId });
  }, [accountId, from, isNativeEmbed, item]);
}
